import { CountUp } from 'countup.js';

const animatedCounter = (counters) => {
  if (counters.length && 'IntersectionObserver' in window) {
    const observerOptions = {
      threshold: 0.5,
    };

    const intObserverCounters = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const cntr = entry.target;
          cntr.countUp.start();
          intObserverCounters.unobserve(cntr);
        }
      });
    }, observerOptions);

    counters.forEach((cnt) => {
      if (cnt.value == null) {
        const val = cnt.getAttribute('data-value') || cnt.textContent;
        cnt.value = parseFloat(val.replace(/,/g, ''));
      }

      // cnt.countUp = new CountUp(cnt, 0, cnt.value, 0, 1.5);
      cnt.countUp = new CountUp(cnt, cnt.value, {
        duration: 2,
      });
      intObserverCounters.observe(cnt);
    });
  }
};

export default animatedCounter;
